<template>
    <div class="layer">
        <div class="wrap">
            <HeaderLayout></HeaderLayout>
            <div class="content">
                <p class="page_title"> 커뮤니티 </p>
                <div class="bo_view">
                    <div class="bo_view_tit">
                        <span class="tit">
                            <p v-html="contentDecode(content.title)"></p>
                        </span>
                        <span class="info">{{ content.date }}</span>
                        <button type="button" class="bo_info_btn" @click="showModifyBtn"
                            v-if="content.meIdx === state.userInfo.idx">
                            <i></i>
                            <i></i>
                            <i></i>
                        </button>
                        <div class="bo_modify_box" :style="state.isBtnShow ? 'display:block' : 'display:none'">
                            <button type="button" class="modify_btn" @click="modifyContent(content.idx)">수정</button>
                            <span></span>
                            <button type="button" class="modify_btn" @click="deleteBtn()">삭제</button>
                        </div>
                    </div>
                    <div class="board_info">
                        <span>
                            <img src="@/assets/user/bo_view_ico.png" alt="">
                            <b>{{ numberFormat(content.cntRead) }}</b>
                        </span>
                        <span>
                            <img src="@/assets/user/bo_good_ico.png" alt="">
                            <b>{{ content.cntLike }}</b>
                        </span>
                        <span>
                            <img src="@/assets/user/bo_bad_ico.png" alt="">
                            <b>{{ content.cntBad }}</b>
                        </span>
                        <span>
                            <img src="@/assets/user/bo_comment_ico.png" alt="">
                            <b>{{ content.cntComment }}</b>
                        </span>
                    </div>
                    <div class="bo_view_content" v-html="contentDecode(content.content)">
                    </div>
                    <div class="bo_gb_btns">
                        <button type="button" class="good_btn" @click="pushLike"
                            :class="state.isLike === true ? 'active' : ''">
                            <img src="@/assets/user/good_ico.png" class="off" />
                            <img src="@/assets/user/good_ico_on.png" class="on" />
                            <span>좋아요 [{{ content.cntLike }}]</span>
                        </button>
                        <button type="button" class="bad_btn" @click="pushBad"
                            :class="state.isBad === true ? 'active' : ''">
                            <img src="@/assets/user/bad_ico.png" class="off" alt="" />
                            <img src="@/assets/user/bad_ico_on.png" class="on" alt="" />
                            <span>싫어요 [{{ content.cntBad }}]</span>
                        </button>
                    </div>
                    <Comment :contentIdx="content.idx" :cntComment="content.cntComment"></Comment>
                </div>
                <div class="board_btns">
                    <router-link to="#" @click="backToList">목록</router-link>
                </div>
            </div>
        </div>
    </div>
    <GnbLayout></GnbLayout>
    <ModalComponent :show="state.isModalOpen" :yes="modal.confirm" :no="modal.cancel" :content="modal.content"
        @close="modalClose"> </ModalComponent>
</template>
<script lang="ts" config>
import {
    HeaderLayout,
    GnbLayout,
    apiService,
    globalStore,
    onMounted,
    reactive,
    router,
    useRoute,
    watch,
    userStore,
    UserInfo,
    ModalComponent,
    numberFormat,
} from "@/BaseComponent";
import Comment from "@/components/communityComment.vue";
export default {
    components: {
        HeaderLayout,
        GnbLayout,
        ModalComponent,
        Comment,
    },
    setup() {
        const route = useRoute();
        const user = userStore();
        const state = reactive({
            isBtnShow: false,
            data: {} as any,
            userInfo: {} as UserInfo,
            selectCategoryIdx: 0 as number,
            isModalOpen: false as boolean,
            isNavOpen: true as boolean,
            isDropMenu: false as boolean,
            isCommentMenu: false as boolean,
            isReCommentMenu: false as boolean,
            isLike: false as boolean,
            isBad: false as boolean,
            isMyWrite: false as boolean,
        });
        const content = reactive({
            idx: route.params.idx as any,
            meIdx: 0 as number,
            title: "" as string,
            date: "" as string,
            content: "" as any,
            youtubeLink: "" as string,
            titleImg: "" as string,
            cntLike: 0 as number,
            cntBad: 0 as number,
            cntRead: 0 as number,
            cntComment: 0 as number,
        });


        const modal = reactive({
            content: "" as string,
            confirm: "" as string,
            cancel: "" as string,
            actionCode: 0 as number,
        });

        const global = globalStore();
        state.isNavOpen = global.isNavOpen;

        onMounted(() => {
            getDetail(content.idx);
            state.userInfo = user.userInfo as UserInfo;
        });

        watch(route, () => {
            content.idx = route.params.idx;
            getDetail(content.idx);
        });

        const getDetail = async (idx: number) => {
            const res = await apiService.community.getDetail(idx);
            if (res.returnCode === 0) {
                if (res.data.meIdx === state.userInfo.idx) {
                    state.isMyWrite = true;
                }
                content.title = res.data.title;
                content.cntRead = res.data.cntRead;
                content.date = formatDate(res.data.updateDate || res.data.createDate);
                content.content = contentDecode(res.data.content);
                content.cntLike = res.data.cntGood;
                content.cntBad = res.data.cntBad;
                content.cntComment = res.data.cntComment;
                content.meIdx = res.data.meIdx;
                state.isLike = res.data.isGood;
                state.isBad = res.data.isBad;
            } else {
                state.isModalOpen = true;
                modal.content = "잘못된 접근입니다.";
                modal.confirm = "확인";
                modal.cancel = "";
                modal.actionCode = 2;
            }
        };

        const pushLike = async () => {
            const res = await apiService.community.like(content.idx);
            if (res.returnCode === 0) {
                if (state.isLike === true) {
                    content.cntLike--;
                    state.isLike = !state.isLike;
                } else if (state.isLike === false) {
                    content.cntLike++;
                    state.isLike = !state.isLike;
                }
            }
        };
        const pushBad = async () => {
            const res = await apiService.community.bad(content.idx);
            if (res.returnCode === 0) {
                if (state.isBad === true) {
                    content.cntBad--;
                    state.isBad = !state.isBad;
                } else if (state.isBad === false) {
                    content.cntBad++;
                    state.isBad = !state.isBad;
                }
            }
        };
        const deleteContentApi = async () => {
            const res = await apiService.community.deleteContent(content.idx);
            if (res.returnCode === 0) {
                state.isModalOpen = true;
                modal.content = "게시글이 삭제되었습니다.";
                modal.confirm = "확인";
                modal.cancel = "";
                modal.actionCode = 2;
            }
        };

        const deleteBtn = () => {
            state.isModalOpen = true;
            modal.content = '게시글을 삭제하시겠습니까?';
            modal.confirm = '삭제';
            modal.cancel = '취소';
            modal.actionCode = 1;
        };

        const backToList = () => {
            router.push('/community/list');
        };

        const formatDate = (isoDateString: string): string => {
            const date = new Date(isoDateString);

            const year = date.getFullYear();
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const day = ("0" + date.getDate()).slice(-2);
            const hours = ("0" + date.getHours()).slice(-2);
            const minutes = ("0" + date.getMinutes()).slice(-2);

            const formattedDateString = `${year}.${month}.${day} ${hours}:${minutes}`;

            return formattedDateString;
        };

        const showDropdownMenu = () => {
            state.isDropMenu = !state.isDropMenu;
        };

        const commentTotlaCntAdd = () => {
            content.cntComment++;
        };
        const commentTotlaCntSubtract = () => {
            content.cntComment--;
        };

        const modalClose = (result: boolean) => {
            state.isModalOpen = false;
            if (result) {
                switch (modal.actionCode) {
                    case 1:
                        deleteContentApi();
                        modal.actionCode = 0;
                        break;
                    case 2:
                        backToList();
                        modal.actionCode = 0;
                        break;

                    default:
                        break;
                }
            } else {

            }
        };

        const showModifyBtn = () => {
            state.isBtnShow = !state.isBtnShow;
        };

        const modifyContent = (idx: number) => {
            router.push({
                path: '/community/write',
                state: { idx: idx, title: content.title, content: content.content }
            });
        };

        const contentDecode = (text: string) => {
            const tempContent = text.replace(/\n/g, '<br>').replace(/\\n/g, '<br>');
            return tempContent;
        };
        return {
            user,
            state,
            content,
            modal,
            router,
            backToList,
            pushLike,
            pushBad,
            showDropdownMenu,
            modalClose,
            numberFormat,
            commentTotlaCntSubtract,
            commentTotlaCntAdd,
            showModifyBtn,
            deleteBtn,
            modifyContent,
            contentDecode,
        };
    },
};
</script>
